
import { PureComponent } from 'react';

import { MEDIA_TYPE } from '../../base/media';
import { forcemuteRemote } from '../actions';

/**
 * The type of the React {@code Component} props of
 * {@link AbstractForceMuteRemoteParticipantsVideoDialog}.
 */
export type Props = {

    /**
     * The Redux dispatch function.
     */
    dispatch: Function,

    /**
     * The Video disable parameter.
     */
     _lockVideo: Object,

    /**
     * The ID of the remote participant to be muted.
     */
    participantID: string,

    /**
     * Function to translate i18n labels.
     */
    t: Function
};

/**
 * Abstract dialog to confirm a remote participant video ute action.
 *
 * @augments Component
 */
export default class AbstractForceMuteRemoteParticipantsVideoDialog<P:Props = Props>
    extends PureComponent<P> {
    /**
     * Initializes a new {@code AbstractMuteRemoteParticipantsVideoDialog} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: P) {
        super(props);

        // Bind event handlers so they are only bound once per instance.
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit: () => boolean;

    /**
     * Handles the submit button action.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    _onSubmit() {
        const { dispatch, participantID } = this.props;

        dispatch(forcemuteRemote(participantID, MEDIA_TYPE.VIDEO));

        return true;
    }
}

/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @private
 * @returns {{
 *      _audioTrackMuted: boolean
 *  }}
 */
export function _mapStateToProps(state: Object) {
    const { lockVideo } = state['features/base/conference'];


    return {
        _lockVideo: lockVideo
    };
}
